module.exports = __webpack_public_path__ + "img/mengHu3.1e3ede0e.png";